module.exports = __webpack_public_path__ + "static/media/band.6d4161cd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/static/band.jpeg
// module id = 514
// module chunks = 0